// ─── Formatting utilities ─────────────────────────────────────────────────────

export function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatCurrency(value, { compact = false } = {}) {
  if (compact && value >= 1000) return `$${(value / 1000).toFixed(0)}k`;
  return `$${value.toLocaleString()}`;
}

export function formatPct(current, target) {
  if (!target) return 0;
  return Math.min(100, Math.round((current / target) * 100));
}